import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, CheckBoxValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class CheckBoxHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    // å¤éæ¡çqc.compareType åªæç­äº
    const arr = [];
    const tv = (qc.value as CheckBoxValue);
    if (tv.value.length == 1) {
      return [{
        'FilterField': qc.fieldCode,
        'Compare': CompareType.Equal,
        'Value': tv.value[0],
        'Relation': (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And,
        'Expresstype': ValueType.Value,
        'Lbracket': qc.Lbracket || null,
        'Rbracket': qc.Rbracket || null
      }];
    }
    tv.value.forEach((tvv) => {
      arr.push({
        'FilterField': qc.fieldCode,
        'Compare': CompareType.Equal,
        'Value': tvv,
        'Relation': RelationType.Or,
        'Expresstype': ValueType.Value
      });
    });
    arr[0]['Lbracket'] = qc.Lbracket ? (qc.Lbracket + '(') :'(';
    arr[arr.length -1]['Rbracket'] = qc.Rbracket ? (qc.Rbracket + ')') : ')';
    arr[arr.length -1]['Relation'] = (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And;
    return arr;
  }
}
